@if (isPhosphorIcon && phosphorGlyphName) {
<i
  [class]="phosphorFullClasses"
  [style.font-size]="size"
  aria-hidden="true"
></i>
} @else if (!isPhosphorIcon) {
<tui-icon
  [icon]="icon"
  [class]="combinedClasses"
  [style.font-size]="size"
></tui-icon>
}
